import { render, staticRenderFns } from "./Overzicht.vue?vue&type=template&id=44eeb892&scoped=true&"
import script from "./Overzicht.vue?vue&type=script&lang=js&"
export * from "./Overzicht.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44eeb892",
  null
  
)

export default component.exports